import {useState} from 'react';
import DemeritEducationReservationEditStep1Check from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationEditStep1Check';
import DemeritEducationReservationEditStep2Branch from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationEditStep2Branch';
import DemeritEducationReservationEditStep3Period from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationEditStep3Period';
import DemeritEducationReservationEditStep4Center from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationEditStep4Center';
import DemeritEducationReservationEditStep5Time from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationEditStep5Time';
import useUrlQueryStore from '@shared/useUrlQueryStore';

const SHARE_STEP_KEY = 's';

enum ReservationEditStep {
  STEP_1_CHECK, // 대상자 확인
  STEP_2_BRANCH, // 지역 선택
  STEP_3_PERIOD, // 기간 선택
  STEP_4_CENTER, // 교육장 선택
  STEP_5_TIME, // 강의시간 선택
}

export interface DemeritEducationReservationEditFormType {
  branchName: string;
  branchCode: string;
  educationStartDate: Date | null;
  educationEndDate: Date | null;
  centerName: string;
  centerCode: string;
  centerNotice: string;
  classroomCode: string;
  educationDate: Date | null;
  educationStartTime: Date | null;
  educationEndTime: Date | null;
}

interface DemeritEducationReservationEditFormProps {
  vin: string;
}

function DemeritEducationReservationEditForm({vin}: DemeritEducationReservationEditFormProps) {
  const [stepStore, setStepStore] = useUrlQueryStore<{step: ReservationEditStep}>(SHARE_STEP_KEY, {
    step: ReservationEditStep.STEP_1_CHECK,
  });

  const [form, setForm] = useState<DemeritEducationReservationEditFormType>({
    branchName: '',
    branchCode: '',
    educationStartDate: null,
    educationEndDate: null,
    centerName: '',
    centerCode: '',
    centerNotice: '',
    classroomCode: '',
    educationDate: null,
    educationStartTime: null,
    educationEndTime: null,
  });

  function updateForm(partial: Partial<DemeritEducationReservationEditFormType>) {
    setForm({...form, ...partial});
  }

  return (
    <>
      {stepStore.step === ReservationEditStep.STEP_1_CHECK && (
        <DemeritEducationReservationEditStep1Check
          vin={vin}
          onNext={() => setStepStore({step: ReservationEditStep.STEP_2_BRANCH})}
        />
      )}
      {stepStore.step === ReservationEditStep.STEP_2_BRANCH && (
        <DemeritEducationReservationEditStep2Branch
          form={form}
          onUpdateForm={(partial: Partial<DemeritEducationReservationEditFormType>) => updateForm(partial)}
          onNext={() => setStepStore({step: ReservationEditStep.STEP_3_PERIOD})}
        />
      )}
      {stepStore.step === ReservationEditStep.STEP_3_PERIOD && (
        <DemeritEducationReservationEditStep3Period
          form={form}
          onUpdateForm={(partial: Partial<DemeritEducationReservationEditFormType>) => updateForm(partial)}
          onNext={() => setStepStore({step: ReservationEditStep.STEP_4_CENTER})}
        />
      )}
      {stepStore.step === ReservationEditStep.STEP_4_CENTER && (
        <DemeritEducationReservationEditStep4Center
          form={form}
          onUpdateForm={(partial: Partial<DemeritEducationReservationEditFormType>) => updateForm(partial)}
          onNext={() => setStepStore({step: ReservationEditStep.STEP_5_TIME})}
        />
      )}
      {stepStore.step === ReservationEditStep.STEP_5_TIME && (
        <DemeritEducationReservationEditStep5Time
          vin={vin}
          form={form}
          onUpdateForm={(partial: Partial<DemeritEducationReservationEditFormType>) => updateForm(partial)}
        />
      )}
    </>
  );
}

export default DemeritEducationReservationEditForm;
